import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLLECT_STATUS_CONFIG } from '../../../../constants';
import { CollectProductData, CollectStatus } from '../../../../types';
import * as Styled from './StatusPanels.styles';

interface LessQuantityPanelProps {
  product: CollectProductData;
  onConfirm: (quantity: number) => void;
  onCancel: () => void;
}

const config = COLLECT_STATUS_CONFIG[CollectStatus.LESS];

const LessQuantityPanel = ({
  product,
  onConfirm,
  onCancel,
}: LessQuantityPanelProps) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState<number>(
    Math.max(1, product.quantity - 1)
  );

  return (
    <Styled.PanelContainer
      accentColor={config.color}
      accentBackground={config.background}
      accentBorder={config.border}
    >
      <div className="panel-title">
        {t('OrderPage.Collect.LessModal.TITLE')}
      </div>
      <Styled.QuantityControl>
        <span className="ordered">
          {t('OrderPage.Collect.LessModal.ORDERED', {
            quantity: product.quantity,
          })}
        </span>
        <button
          type="button"
          className="count-button"
          disabled={quantity <= 1}
          onClick={() => setQuantity(quantity - 1)}
        >
          −
        </button>
        <span className="count" style={{ color: config.color }}>
          {quantity}
        </span>
        <button
          type="button"
          className="count-button"
          disabled={quantity >= product.quantity - 1}
          onClick={() => setQuantity(quantity + 1)}
        >
          +
        </button>
      </Styled.QuantityControl>
      <div className="panel-hint">
        {t('OrderPage.Collect.LessModal.ZERO_HINT')}
      </div>
      <div className="panel-actions">
        <button
          type="button"
          className="panel-button cancel"
          onClick={onCancel}
        >
          {t('OrderPage.Collect.LessModal.CANCEL')}
        </button>
        <button
          type="button"
          className="panel-button confirm"
          style={{ background: config.color }}
          onClick={() => onConfirm(quantity)}
        >
          {t('OrderPage.Collect.LessModal.CONFIRM', { quantity })}
        </button>
      </div>
    </Styled.PanelContainer>
  );
};

export default LessQuantityPanel;
